import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

const ReactSwal = withReactContent(Swal);

export const SWAL_UPHEAL_TARGET_ELEMENT_ID = 'swal-upheal-target-element-id';

export const SwalUpheal = ReactSwal.mixin({
    target: `#${SWAL_UPHEAL_TARGET_ELEMENT_ID}`,
}) as typeof ReactSwal;

export const swalSuccessIcon = (
    <div
        className="swal2-icon swal2-success swal2-icon-show"
        style={{ display: 'flex' }}
    >
        <div className="swal2-success-circular-line-left"></div>
        <span className="swal2-success-line-tip"></span>{' '}
        <span className="swal2-success-line-long"></span>
        <div className="swal2-success-ring"></div>{' '}
        <div className="swal2-success-fix"></div>
        <div className="swal2-success-circular-line-right"></div>
    </div>
);

export const swalWarningIcon = (
    <div
        className="swal2-icon swal2-warning swal2-icon-show"
        style={{ display: 'flex' }}
    >
        <div
            className="swal2-icon-content"
            style={{ transform: 'translateX(-0.75px)' }}
        >
            !
        </div>
    </div>
);
